module.exports = __webpack_public_path__ + "img/jobs-education.svg";